module.exports = __webpack_public_path__ + "img/ethereum-eth-logo.7c199546.svg";